import Haikubox from "./Haikubox.vue";
import Haikumarine from "./Haikumarine.vue";
import Settings from "./components/Settings.vue";
import Privacy from "./components/Privacy.vue";
import Terms from "./components/Terms.vue";
import Label from "./components/Label.vue";
import Landing from "./components/Landing.vue";
import Admin from "./components/Admin.vue";
import Grid from "./components/Grid.vue";
import Notifications from "./components/Notifications.vue";
import Favorites from "./components/Favorites.vue";
import Support from "./components/Support.vue";
import Success from "./components/Success.vue";
import Videohaikuboxoverview from "./components/Videohaikuboxoverview.vue"
import Status from "./components/Status.vue";
import Science from "./components/Science.vue";
import Groups from "./components/Groups.vue";
import GroupDashboard from "./components/GroupDashboard.vue";
// import router from "./main.js"
// import { Auth } from 'aws-amplify';

// var authState = true;

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     // this route requires auth, check if logged in
//     // if not, redirect to login page.
//     Auth.currentAuthenticatedUser().then(authData => {
//       console.log("router authData", authData);
//     });
//     console.log("router auth state", authState);
//     if (!authState) {
//       next({
//         path: '/landing',
//         query: { redirect: to.fullPath }
//       })
//     } else {
//       next()
//     }
//   } else {
//     next() // does not require Auth
//   }
// })

export const routes = [
  { path: "/haikubox", component: Haikubox, meta: { requiresAuth: true }},
  { path: "/settings", component: Settings, meta: { requiresAuth: true }},
  { path: "/success", component: Success, meta: { requiresAuth: true }},
  { path: "/privacy", component: Privacy, meta: { requiresAuth: false }},
  { path: "/terms", component: Terms, meta: { requiresAuth: false }},
  { path: "/marine", component: Haikumarine,meta: { requiresAuth: true }},
  { path: "/label", component: Label, meta: { requiresAuth: true }},
  { path: "/admin", component: Admin, meta: { requiresAuth: true }},
  { path: "/grid", component: Grid, meta: { requiresAuth: true }},
  { path: "/notifications", component: Notifications, meta: { requiresAuth: true }},
  { path: "/favorites", component: Favorites, meta: { requiresAuth: true }},
  { path: "/support", component: Support, meta: { requiresAuth: false }},
  { path: "/videohaikuboxoverview", component: Videohaikuboxoverview, meta: { requiresAuth: false }},
  { path: "/status", component: Status, meta: { requiresAuth: true }},
  { path: "/science", component: Science, meta: { requiresAuth: true, requiresAdmin: true }},
  { path: "/groups", component: Groups, meta: { requiresAuth: true }},
  { path: "/groups/:slug", component: GroupDashboard, meta: { requiresAuth: false }},
  { path: "/groups/:slug/:serial", component: GroupDashboard, meta: { requiresAuth: false }},
  { path: "", component: Landing, meta: { requiresAuth: false }}
];
